import { ChangeEvent, InputHTMLAttributes } from 'react'

import { CheckboxLabel } from './styles'

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  labelText?: string
  onChange?: (e: ChangeEvent<any>) => void
}

function Checkbox({
  checked,
  disabled,
  labelText = '',
  onChange,
  ...rest
}: CheckboxProps) {
  return (
    <CheckboxLabel hasLabelText={!!labelText}>
      <input
        {...rest}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span>{labelText}</span>
    </CheckboxLabel>
  )
}

export default Checkbox
